import { useContext } from 'react';
import { MarketContext } from 'context/market';
import { useFormat } from 'helpers/hooks/useFormat';

const InvalidCountryAlert: React.FC = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const { openMarketDrawer } = useContext(MarketContext);

  return (
    <div className="mb-8 border-l-4 border-red-500 bg-red-100 p-4 text-red-700" role="alert">
      <p>
        {formatMessage({
          id: 'error.invalidCountry',
          defaultMessage: 'Il paese selezionato non è disponibile per gli acquisti.',
        })}
      </p>
      <button type="button" className="mt-2 font-semibold underline" onClick={openMarketDrawer}>
        {formatMessage({ id: 'error.invalidCountry.cta', defaultMessage: 'Cambia paese' })}
      </button>
    </div>
  );
};

export default InvalidCountryAlert;
